var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.091 29.528",
    style: {
      fill: "currentColor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M14.764,16.61a8.3,8.3,0,1,0-8.3-8.3A8.307,8.307,0,0,0,14.764,16.61Zm7.382,1.846H18.968a10.039,10.039,0,0,1-8.409,0H7.382A7.381,7.381,0,0,0,0,25.837v.923a2.769,2.769,0,0,0,2.768,2.768H26.76a2.769,2.769,0,0,0,2.768-2.768v-.923A7.381,7.381,0,0,0,22.146,18.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-pencil",
    "data-name": "Icon metro-pencil",
    d: "M13.529,1.928a2.029,2.029,0,0,1,1.623,3.247l-.812.812L11.5,3.146l.812-.812a2.02,2.02,0,0,1,1.218-.406ZM3.382,11.263l-.812,3.653L6.224,14.1,13.732,6.6,10.891,3.754Zm8.264-4.724L5.965,12.222l-.7-.7L10.947,5.84l.7.7Z",
    transform: "translate(28.532 12.836)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5cba9e0931bce11ea78ecc6db6973fac.svg";
export { ForwardRef as ReactComponent };